module.exports = __webpack_public_path__ + "img/banner-img4x.png";